var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property, css, html, LitElement } from 'lit-element';
import i18n from 'roddeh-i18n';
import WishlistStorage from '../services/wishlist-storage';
let WishlistButton = class WishlistButton extends LitElement {
    constructor() {
        super(...arguments);
        this.sku = '';
        this.altshop_id = 0;
        this.added = false;
    }
    static get styles() {
        return css `
            :host {
                cursor: pointer;
                user-select: none;
            }

            .main {
                display: flex;
            }

            .main .placeholder {
                align-self: flex-start;
            }

            .heart {
                color: #000;
                width: 30px;
                height: 30px;
                display: inline-block;
                vertical-align: middle;
            }

            .heart .full,
            .heart .bordered {
                transition:
                    opacity 0.3s ease-out,
                    fill 0.3s ease-out;
            }

            .added .heart .full {
                opacity: 1;
            }
            .added .heart .bordered {
                opacity: 0;
            }

            @media (hover) {
                .not-added:hover .heart .full {
                    opacity: 1;
                }
                .not-added:hover .heart .bordered {
                    opacity: 0;
                }

                .added:hover .heart .full {
                    fill: #143616;
                }

                .placeholder {
                    margin-right: 3px;
                    font-family: 'Open Sans', sans-serif;
                    font-weight: 600;
                    font-size: 0.8em;
                    vertical-align: top;
                    opacity: 0;
                    transition: opacity 0.3s ease-out;
                    background: rgba(255, 255, 255, 0.9);
                    border-radius: 1em;
                    padding-left: 3px;
                }
                .main:hover .placeholder {
                    opacity: 1;
                }
            }
            @media (hover: none) {
                .placeholder {
                    display: none;
                }
            }
            @media (max-width: 425px) {
                .placeholder {
                    font-size: 0.7em;
                    text-align: center;
                }
            }
        `;
    }
    render() {
        return html `<div class="main${this.added ? ' added' : ' not-added'}" @click="${this.toggle}">
            <span class="placeholder"> ${i18n(this.added ? 'on your wishlist' : 'add to wishlist')} </span>
            <span class="heart">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27.39 25.42">
                    <defs>
                        <style>
                            .full {
                                fill: #b41542;
                                fill-rule: evenodd;
                                opacity: 0;
                            }
                            .bordered {
                                fill: #b41542;
                            }
                        </style>
                    </defs>
                    <path
                        class="full"
                        d="M4.75.36c-5.19,1.79-6.86,8-1.24,14.94A54.59,54.59,0,0,0,13.73,25.41,54.81,54.81,0,0,0,23.88,15.3c5.63-7,4-13.15-1.24-14.94S13.73,4,13.73,4,10-1.43,4.75.36Z"
                    />
                    <path
                        class="bordered"
                        d="M20.54,2A4.34,4.34,0,0,1,22,2.25a4.73,4.73,0,0,1,3.2,3.2c.68,2.37-.36,5.5-2.86,8.59a53.33,53.33,0,0,1-8.63,8.84A60.63,60.63,0,0,1,5.06,14C2.56,11,1.52,7.82,2.2,5.45a4.75,4.75,0,0,1,3.21-3.2A4.34,4.34,0,0,1,6.86,2c3,0,5.2,3.14,5.22,3.16l1.66,2.39,1.64-2.4S17.61,2,20.54,2h0m0-2c-4.07,0-6.81,4-6.81,4S10.94,0,6.86,0a6.44,6.44,0,0,0-2.1.36c-5.2,1.79-6.87,8-1.25,14.94A55.26,55.26,0,0,0,13.73,25.42,55.32,55.32,0,0,0,23.89,15.3c5.62-7,3.95-13.15-1.24-14.94A6.54,6.54,0,0,0,20.54,0Z"
                    />
                </svg>
            </span>
        </div>`;
    }
    connectedCallback() {
        super.connectedCallback();
        // Widoki WebView nie wspierają localStorage, ukrywamy komponent
        if (!WishlistStorage.isSupported()) {
            this.style.display = 'none';
            return;
        }
        this.added = WishlistStorage.has(this.sku);
        // Nasłuchujemy na zmianę stanu dowolnego SKU na wishliście tak, aby w sytuacji, kiedy inny element
        // zmieni stan "naszego" SKU, zaktualizować swój stan
        WishlistStorage.addListener((sku) => this.onWishlistChange(sku));
        // Upewniamy się, że usłucha synchronizacji jest uruchomiona
        WishlistStorage.registerSync();
    }
    onWishlistChange(sku) {
        if (sku === this.sku) {
            this.added = WishlistStorage.has(this.sku);
        }
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        // Wsparcie dla zmiany SKU już po utworzeniu elementu - wymuszamy przeliczenie pola "added"
        if (changedProperties.has('sku') && typeof changedProperties.get('sku') === 'string') {
            this.added = WishlistStorage.has(this.sku);
        }
    }
    async toggle() {
        if (this.added) {
            this.added = false;
            await WishlistStorage.remove(this.sku, this.altshop_id);
        }
        else {
            this.added = true;
            await WishlistStorage.add(this.sku, this.altshop_id);
            // Zdarzenie Google Analytics
            window.dispatchEvent(new CustomEvent('ga-event', {
                detail: {
                    place: 'Wishlist',
                    action: 'Added to Wishlist',
                    value1: this.sku,
                },
            }));
            window.dispatchEvent(new CustomEvent('wishlist-add', {
                detail: { sku: this.sku },
            }));
        }
    }
};
__decorate([
    property({ type: String })
], WishlistButton.prototype, "sku", void 0);
__decorate([
    property({ type: Number })
], WishlistButton.prototype, "altshop_id", void 0);
__decorate([
    property({ type: Boolean })
], WishlistButton.prototype, "added", void 0);
WishlistButton = __decorate([
    customElement('wishlist-button')
], WishlistButton);
export default WishlistButton;
